import React, { useEffect, useState } from 'react'
import MainLayouts from '../../layouts/MainLayouts'
import _Api from '../../services/Api/_Api'
import { _Button, _Checkbox, _Input, _Select, _Date } from '../../services/Forms/Forms'

import { Table, Form, Popover, Button, Tag, Popconfirm, Radio, DatePicker, Checkbox, Modal } from 'antd';
import { RandomText } from '../../services/Text/RandomText';
import { DeleteColumnOutlined, DownSquareOutlined, DropboxOutlined, EditOutlined, FieldTimeOutlined, FileSearchOutlined, MinusSquareOutlined, PlusSquareOutlined, RightSquareOutlined } from '@ant-design/icons';
import { _Col, _Row } from '../../services/Forms/LayoutBootstrap';
// import ExpandShowDataPengadaan from './Expand_ShowDataPengadaan';
import moment from 'moment';
import { useHistory } from 'react-router';
// import EditPekerjaan from './EditPekerjaan';
import { SocketIO, TglSekarang, fDB, formatNumber, formatTglWaktu, globalText } from '../../services/Text/GlobalText';
import { Col, Row } from 'react-bootstrap';
import { _Toastr } from '../../services/Toastr/Notify/_Toastr';
import { acakText, ubahText } from '../../services/Crypto';
import dayjs from 'dayjs';
import { baseURL_R_file } from '../../services/BaseUrl';
import CountDownX from '../../services/Forms/CountDown';
import { dataUser } from '../../services/Cache/Auth';


function RiwayatKonseling() {

    const [steps, setsteps] = useState(0)
    const [jenisPekerjaan, setjenisPekerjaan] = useState([])
    const [riwayatKonseling, setriwayatKonseling] = useState([])
    const [ppk, setppk] = useState([])
    const [loading, setloading] = useState(false)
    const [jenispk, setjenispk] = useState("")
    const [formLoad] = Form.useForm()
    const [edit, setedit] = useState(false)
    const [recordData, setrecordData] = useState([])
    const [jenisArsip, setjenisArsip] = useState([])


    var histori = useHistory()

    // const DragHandle = sortableHandle(() => <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />);


    const mulaiKonseling = (rc) => {
        histori.push({
            pathname: '/VideoCallKonseling',
            search: '?konsId=' + rc.id + "&dvId=" + rc.deviceid + "&xtemp=" + acakText("123")
        })

        // window.location.href = "/ProsesKonseling?konsId=" + rc.id + "&xtemp=" + acakText("123")

    }

    const editData = (rc) => {
        histori.push({
            pathname: '/OrderKonseling',
            search: '?konsId=' + rc.id + "&dvId=" + rc.deviceid + "&xtemp=" + acakText("123")
        })
    }
    const hapusBerkas = (rc) => {
        console.log('rc', rc)
        _Api.delete("deleteProyek?id=" + rc.id).then(res => {
            console.log('res', res)
            if (res.data.sts == 1) {
                _Toastr.success('Berhasil')
                loadData()
            }
        })
    }


    const columns = [
        {
            title: '',
            width: "70px",
            align: 'center',
            render: (record, i, j) =>
                <div style={{ textAlign: "center" }}>
                    <Button type="primary" size='large' shape="shape" icon={<FieldTimeOutlined />} onClick={() => editData(record)} > Detail </Button>
                    {/* <Popover placement="bottom" content={<div> Edit </div>}>
                    </Popover> */}

                </div>

        },
        {
            title: 'No',
            width: "50px",
            align: 'center',
            sorter: true,
            render: (record, i, j) =>
                <div style={{ textAlign: "center" }}>
                    {j + 1}.

                </div>
        },
        {
            title: 'Tanggal Rencana Konseling',
            width: "70px",
            sorter: true,
            render: (record, i, j) =>
                <div style={{ textAlign: "center" }}>
                    {record.tgl && moment(record.tgl).format('DD-MM-YYYY H:m')} Wita

                </div>
        },
        {
            title: 'Jumlah Tagihan',
            width: "130px",
            align: 'center',
            sorter: true,
            render: (record, i, j) =>
                <center> <b>
                    Rp. {formatNumber(record.tagihan)}
                </b>
                </center>
        },
        {
            title: 'Metode Pembayaran / Batas Pembayaran',
            sorter: true,
            width: "100px",
            render: (_, rc) =>
                <center>
                    <b style={{ textTransform: "capitalize" }}>  {rc.metodebayar} </b>
                    {
                        rc.status == "MP" &&
                        <>
                            <CountDownX tgl={rc.batasbayar} />
                            {rc.batasbayar && moment(rc.batasbayar).format('DD-MM-YYYY H:m')} Wita
                        </>
                    }
                </center>
        },
        {
            title: 'Bank Tujuan Transfer',
            sorter: true,
            width: "90px",
            render: (_, rc) =>
                <div> <b>     </b>
                {
                    rc.bank == "MANUAL" ? "MANUAL" :
                    <img height={40} src={baseURL_R_file + "images/bank/" + rc.bank + ".png"} alt={rc.bank} />
                }
                </div>
        },
        {
            title: 'Status',
            sorter: true,
            width: "100px",
            render: (_, rc) =>
                <>
                    <div style={{ lineHeight: "100%" }} className={'p-2 text-center rounded b bg-' + rc.class} > {rc.jenistransaksi} </div>
                    {
                        rc.status == "KPK" && // KPK = Konfirmasi Pembayaran Konseling
                        <_Button className="blink_me mt-1" onClick={() => mulaiKonseling(rc)} label="Mulai Konseling" block size="large" />
                    }
                </>
            // <div style={{ lineHeight: "100%" }} className={'p-2 text-center b bg-' + rc.class} > {rc.jenistransaksi} </div>
        },
        {
            title: 'Kode',
            width: "70px",
            align: 'center',
            sorter: true,
            render: (record, i, j) =>
                <div style={{ textAlign: "center" }}>
                    <b>  {record.kodeorderkonseling}</b>

                </div>
        },
        {
            title: 'Catatan Petugas Gizi',
            sorter: true,
            width: "100px",
            render: (_, rc) =>
                <div>
                    <b> {rc.jenispekerjaan} <br /> <Tag color="yellow" style={{ textTransform: "uppercase" }}> {rc.bidang} </Tag> </b>
                </div>
        },


    ];

    const stile = {
        icon: { fontSize: "25px", color: "orange" }
    }

    const loadData = (val) => {
        setriwayatKonseling([])
        setedit(false)
        if (val) {
            var param = {
                ...val,
                tglawal: val.tglawal ? moment(val.tglawal).format('YYYY-MM-DD 00:00:00') : "",
                tglakhir: val.tglakhir ? moment(val.tglakhir).format('YYYY-MM-DD 23:59:59') : ""
            }
        } else {
            var param = val
        }

        setloading(true)
        _Api.get("/get-riwayat-konseling", { params: param }).then(res => {
            setriwayatKonseling(res.data)

            setloading(false)
        })
    }

    const loadCombo = (val) => {
        setloading(true)
        _Api.post("getMasterData", { "masterData": "pegawai_m", ...val }).then(res => {
            setppk(res.data)
        })

        _Api.post("getMasterData", { "masterData": "arsip_jenispekerjaan_m" }).then(res => {
            setjenisPekerjaan(res.data)
        })
        _Api.post("getMasterData", { "masterData": "jenisarsip_m" }).then(res => {
            setjenisArsip(res.data)
        })
    }

    useEffect(() => {
        var role = ubahText(sessionStorage.getItem('x-auth-user'))
        console.log('role', role)
        // loadData()
        formLoad.submit()
        // loadCombo()
    }, [])

    useEffect(() => {
        var pb_id = dataUser.user.id_pembeli

        SocketIO.on("konfirmasipembayaran", (data) => {
            if (data.pembeli_id == pb_id) {
                formLoad.submit()

            }
        })
    }, [])

    const listStatus = [
        {
            label: 'Draft',
            value: 'Draft',
        },
        {
            label: 'Menunggu Pembayaran',
            value: 'mp',
        },
        {
            label: 'Pembayaran Selesai',
            value: 'ps',
        },
    ];
    return (
        <MainLayouts>
            <br />
            <h3 className='text-center'> RIWAYAT KONSELING </h3>
            <Form layout='vertical' onFinish={loadData} initialValues={{ tglawal: moment(), tglakhir: moment() }} form={formLoad} >
                {/* <_Input label="Nama Pekerjaan" onChange={e => console.log(e.target.value)} /> */}
                <Row>
                    <_Date label="Tanggal" sm={2} name="tglawal" format="DD-MM-YYYY 00:00" />
                    <_Date label="Sampai" sm={2} name="tglakhir" format="DD-MM-YYYY 23:59" />
                    {/* <_Select size="large" option={jenisPekerjaan}
                        val="id" name="status" sm={2}
                        caption="jenispekerjaan" label="Status" /> */}
                    <Col sm={4}>
                        <Form.Item name="status" label="Status">
                            <Checkbox.Group
                                options={listStatus}
                                defaultValue={['Apple']}
                            />
                        </Form.Item>
                    </Col>
                    <_Button className='mt-1' label="Refresh" icon={<FileSearchOutlined />} sm={2} block submit />
                    <_Button className='mt-1' label="Tambah Konseling" icon={<DropboxOutlined />} onClick={() => histori.push("/OrderKonselingManual")} color="green" sm={2} block />
                </Row>
            </Form>

            {/* {edit && <EditPekerjaan show={edit} close={() => setedit(false)} loadData={loadData} recordData={recordData} />} */}
            <br />
            <Table size="large"
                rowKey="id"
                className='mt-2'
                // loading={loading}
                showSorterTooltip={false}
                expandable={{
                    expandedRowRender: record =>
                        <p style={{ margin: 0 }}>

                        </p>,
                    expandIcon: ({ expanded, onExpand, record }) =>
                        expanded ? (
                            <MinusSquareOutlined style={stile.icon} onClick={e => onExpand(record, e)} />
                        ) : (
                            < PlusSquareOutlined style={stile.icon} onClick={e => onExpand(record, e)} />
                        )
                }}
                scroll={{ y: 500 }}
                pagination={{ pageSize: 30 }}
                columns={columns} dataSource={riwayatKonseling} />
            <br />

        </MainLayouts>
    )
}

export default RiwayatKonseling
